// client/src/locales/en

const de = {
  translation: {
    form: {
      form_submit: 'Formular einreichen',
      make_a_choice: 'Wähle eine Option',
    },
    general: {
      readMore: 'Weiterlesen',
      loading: 'Wird geladen',
      close: 'Schließen',
    },
    blocks: {
      imageContainer: {
        error: 'Fehler beim Laden des Bildes',
      },
      mapBlock: {
        visitWebsite: 'Besuche die Website',
        map: 'Karte',
        list: 'Liste',
      },
      milkPricesTableBlock: {
        labels: {
          year: 'Jahr',
          month: 'Monat',
          guaranteed_price: 'Garantierter Preis',
          average_price: 'Durchschnittspreis',
          protein: 'Protein',
          fat: 'Fett',
          lactose: 'Laktose',
        },
        months: {
          1: 'Januar',
          2: 'Februar',
          3: 'März',
          4: 'April',
          5: 'Mai',
          6: 'Juni',
          7: 'Juli',
          8: 'August',
          9: 'September',
          10: 'Oktober',
          11: 'November',
          12: 'Dezember	',
        },
      },
    },
    searchbar: {
      label: 'Wonach suchen Sie?',
      placeholder: 'Beispiel: Milchpreise',
    },
    header: {
      language: 'Sprache',
    },
    footer: {
      links: {
        privacy: 'Datenschutz-Bestimmungen',
        terms_conditions: 'Terms & Bedingungen',
      },
      follow_us: 'Folge uns',
    },
    404: {
      title: 'Leider können wir die gesuchte Webseite nicht finden',
      description:
        "<p>It seems like the page doesn' exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.</p>",
      link: '/',
      homepage: 'Zur Homepage',
    },
    cookiebar: {
      accept: 'Akzeptieren',
      missing: 'Sie müssen cookies aktivieren um fortfahren zu können.',
    },
    regionSwitch: {
      title: "FrieslandCampina, ihr globaler Milchpartner",
      description: "Wir sind eine globale Molkereigenossenschaft, die in mehr als 50 Ländern aktiv ist",
      language: "Duitsland"
    },
    searchResults: {
      title: 'Ihr Suchbegriff',
      noSearchTerm: 'Sie haben keinen Suchbegriff angegeben',
      types: {
        page: 'Seite',
        news: 'Nachrichten',
        story: 'Geschichte',
      },
      noResults: 'Keine Ergebnisse gefunden. Versuchen Sie es erneut mit diesen Tipps:',
      noResultsTips: {
        spelling: 'Überprüfe deine Rechtschreibung',
        describe: 'Beschreiben Sie Ihre Suche anders',
        shorter: 'Machen Sie Ihre Suche kürzer',
      },
    },
    pagination: {
      previous: 'Vorherige',
      next: 'Nächste',
    },
    show_button: {
      more: 'Mehr anzeigen',
      less: 'Weniger anzeigen',
    },
    share_link: {
      title: 'Teilen auf'
    },
    news: {
      categories: 'Kategorien:'
    },
    story: {
      categories: 'Kategorien:'
    },
    filters: {
      filter_on: 'Filtern nach:',
      category: 'Kategorie',
      all_categories: 'Alle Kategorien',
      year: 'Jahr',
      all_years: 'Alle Jahre'
    }
  },
}

export default de
